export default "__VITE_ASSET__1r0fMuw1__"